const data = [
  {
    date: "31-08-2021",
    name: "Reopening of Schools for Students of Classes 9th to 12th",
    link: "https://chinmayavvdelhi.ac.in/assets/pdfs/454_dt_31082021.pdf",
  },
  {
    date: "08-08-2021",
    name: "SOPs for Dispute Redressal 2021",
    link: "https://chinmayavvdelhi.ac.in/assets/pdfs/20210808-SOPs-for-Dispute-Redressal-2021.pdf",
  },
  {
    date: "14-04-2021",
    name: "CBSE Circular dated 14.04.2021 on Class X and Class XII Board Examinations",
    link: "https://chinmayavvdelhi.ac.in/assets/pdfs/circular140421.pdf",
  },
  {
    date: "12-04-2021",
    name: "Directorate of Education Circular dated 12.04.2021 regarding closure of schools",
    link: "https://chinmayavvdelhi.ac.in/assets/pdfs/226_dt_120420211.pdf",
  },
  {
    date: "18-02-2021",
    name: "CBSE Circular for Nursery Admission Criteria",
    link: "https://chinmayavvdelhi.ac.in/assets/pdfs/Admission-Process-for-the-Open-Seats-(other-than-EWS-DG-category-Seats)-at-entry-level-classes-in-pvt-unaided-recognized-schools-in-delhi-for-the-academic-session-2021-22.PDF",
  },
  {
    date: "",
    name: "Appendix - IX - Mandatory Public Disclosure",
    link: "https://chinmayavvdelhi.ac.in/assets/pdfs/appendix/APPENDIX-IX-MANDATORY-PUBLIC-DISCLOSURE.pdf",
  },
  {
    date: "25-07-2020",
    name: "Annexure - 1 (a) - Affiliation Upgradation Letter and recent extension of Affiliation",
    link: "https://chinmayavvdelhi.ac.in/assets/pdfs/appendix/Annexure-1(a)-Affiliation-Upgradation-Letter-and-recent-extension-of-Affiliation.pdf",
  },
  {
    date: "17-10-2018",
    name: "Annexure - 1 (b) - Affiliation Upgradation Letter and recent extension of Affiliation",
    link: "https://chinmayavvdelhi.ac.in/assets/pdfs/appendix/Annexure-1(b)-Affiliation-Upgradation-Letter-and-recent-extension-of-Affiliation.pdf",
  },
  {
    date: "15-03-2020",
    name: "Annexure - 3 - No Objection Certificate (NOC)",
    link: "https://chinmayavvdelhi.ac.in/assets/pdfs/appendix/Annexure-3-No-Objection-Certificate-(NOC).pdf",
  },
  {
    date: "15-03-2020",
    name: "Annexure - 3 (a) - No Objection Certificate (NOC)",
    link: "https://chinmayavvdelhi.ac.in/assets/pdfs/appendix/Annexure-3(a)-No-Objection-Certificate-(NOC).pdf",
  },
  {
    date: "15-03-2020",
    name: "Annexure - 4 - Recognition Certificate",
    link: "https://chinmayavvdelhi.ac.in/assets/pdfs/appendix/Annexure-4-Recognition-Certificate.pdf",
  },
  {
    date: "14-08-2008",
    name: "Annexure - 5 - Building Safety Certificate",
    link: "https://chinmayavvdelhi.ac.in/assets/pdfs/appendix/Annexure-5-Building-Safety-Certificate.pdf",
  },
  {
    date: "20-04-2017",
    name: "Annexure - 6 - Fire Safety Certificate",
    link: "https://chinmayavvdelhi.ac.in/assets/pdfs/appendix/Annexure-6-Fire-Safety-Certificate.pdf",
  },
  {
    date: "18-04-2018",
    name: "Annexure - 7 - Water Health and Sanitation Certificates",
    link: "https://chinmayavvdelhi.ac.in/assets/pdfs/appendix/Annexure-7-Water-Health-and-Sanitation-Certificates.pdf",
  },
  {
    date: "",
    name: "Annexure - 8 - Fee Structure of the School",
    link: "https://chinmayavvdelhi.ac.in/assets/pdfs/appendix/Annexure-8-Fee-Structure-of-the-School.pdf",
  },
  {
    date: "",
    name: "Annexure - 9 - Annual Academic Calendar",
    link: "https://chinmayavvdelhi.ac.in/assets/pdfs/appendix/Annexure-9-Annual-Academic-Calendar.pdf",
  },
  {
    date: "",
    name: "Annexure - 10 - School Management Committee",
    link: "https://chinmayavvdelhi.ac.in/assets/pdfs/appendix/Annexure-10-School-Management-Committee.pdf",
  },
  {
    date: "",
    name: "Annexure - 11 - List of Parents Teachers Association (PTA) Members",
    link: "https://chinmayavvdelhi.ac.in/assets/pdfs/appendix/Annexure-11-List-of-Parents-Teachers-Association-(PTA)-Members.pdf",
  },
];

export default data;
